<template>
  <div class="conversion-api-test-system">
    <el-row type="flex" justify="center">
      <el-col :span="15">
        <table class="typeB">
          <tr>
            <th>アカウント名</th>
            <td>
              <div style="padding: 10px">{{ accountData.accountName }}</div>
            </td>
          </tr>
          <tr>
            <th>タグID</th>
            <td>
              <div style="padding: 10px; word-break: break-all">
                {{ accountData.ydaTagId }}
              </div>
            </td>
          </tr>
          <tr>
            <th>アクセストークン</th>
            <td>
              <div style="padding: 10px; word-break: break-all">
                {{ accountData.accessToken }}
              </div>
            </td>
          </tr>
        </table>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col>
        <div class="button-cover">
          <el-button @click="sendTestEvent" type="success">テスト送信</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row v-if="resultData !== null" type="flex" justify="center">
      <el-col :span="15">
        <h4>送信結果</h4>
        <div v-if="resultData.eventReceived === true">送信完了</div>
        <div v-else>{{ resultData.errorMessage }}</div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ConversionApiTestSystem",
  components: {},
  props: {
    toolId: String,
    accountId: String,
  },
  data() {
    return {
      resultData: null,
    };
  },
  computed: {
    ...mapGetters(["rt", "apiErrorMessage"]),
    accountData() {
      return this.$store.getters["tools02/accountData"](this.accountId);
    },
  },
  watch: {},
  methods: {
    sendTestEvent() {
      let params = new URLSearchParams();
      params.append("tool_id", this.toolId);
      params.append("account_id", this.accountId);
      this.$axios
        .post(
          `${this.rt}/l/api/tools02/conversion-api/manual-send-conversion-event-by-account`,
          params
        )
        .then((response) => {
          console.log(response);
          if (response.data.status === 200) {
            if (response.data.resultData.eventReceived === true) {
              alert("テスト送信をしました。広告管理画面に反映されているか確認ください。");
            } else {
              alert("テスト送信に失敗しました。");
            }
            this.resultData = response.data.resultData;
          } else if (response.data.status === 401) {
            alert(response.data.message);
            this.$router.push("/");
          } else {
            alert(this.apiErrorMessage);
            return;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.button-cover {
  display: flex;
  justify-content: center;
  align-items: center;

  .el-button {
    margin: 0 20px;
  }
}
</style>
